/* eslint-disable no-console */

// react libraries
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

import reportWebVitals from './reportWebVitals';

import './index.less';

const appContainer = document.getElementById('root');

const appRoot = createRoot(appContainer);

appRoot.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
